/**
 * API base resolution.
 *
 * Production builds set REACT_APP_BACKEND_URL (see the Cloudflare workflows and
 * frontend/wrangler.toml). Without it, a dev server used to fall through to the
 * DHC hub, so `npm start` read and wrote live production data and a local test
 * could create real orders. A dev server now defaults to the local FastAPI
 * instance; point it at the hub deliberately by setting REACT_APP_BACKEND_URL.
 */

export const DHC_HUB_API_BASE = "https://digitalhustlerscaribbean.com";
export const LOCAL_API_BASE = "http://localhost:8001";

const LOCAL_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
  "[::1]",
  "::1",
  "0.0.0.0",
]);

export function isLocalHostname(hostname) {
  return LOCAL_HOSTNAMES.has((hostname ?? "").trim().toLowerCase());
}

/**
 * @param {{ hostname?: string, configured?: string }} [options]
 * @returns {string} Origin with no trailing slash.
 */
export function resolveApiBase({ hostname, configured } = {}) {
  const explicit = (configured ?? "").trim();
  if (explicit) return explicit.replace(/\/+$/, "");
  return isLocalHostname(hostname) ? LOCAL_API_BASE : DHC_HUB_API_BASE;
}
